import React from 'react';
import ContactHero from '../components/ContactHero';
// import ContactInfo from '../components/ContactInfo';
import ContactInquiry from '../components/ContactInquiry';
import ContactFAQ from '../components/ContactFAQ';
import AboutLocation from '../components/AboutLocation';

const ContactPage = () => {
  return (
    <div>
      <ContactHero />
      {/* <ContactInfo /> */}
      <ContactInquiry />
      <ContactFAQ />
      <AboutLocation />
    </div>
  );
};

export default ContactPage;
